import type { PostGenerateResult } from '@cli-types/next-adapter/generators.js'
import { printNextSteps } from '@next-adapter/next-steps.js'

export function printAddNextSteps(
  installKind: 'preset' | 'integration',
  hasSchemaChanges: boolean,
  result: PostGenerateResult,
  adminRoutePath: string
): void {
  printNextSteps({
    reviewLabel: `the installed ${installKind} files`,
    needsMigration: hasSchemaChanges && result.dbPush !== 'success',
    route: adminRoutePath
  })
}
